import React, { FC, useContext } from 'react';

import {
  H3,
  Input,
  ISelectOption,
  NumberInput,
  Select,
} from '@smartshell/ui-kit';
import { Controller } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { LocalizationContext } from 'localization';
import { SettingsContext } from 'settings';
import { EPromoValueType } from 'types';

import s from './FormComponents.module.scss';
import { IFormComponentsProps } from './interfaces';
import { getValuePresentIcon, getValuePresentTitle } from './utils';

export const MainInfoCampaign: FC<IFormComponentsProps> = ({
  control,
  watch,
  usedCodes,
  totalCodes,
  promoOrPromoCampaign,
}) => {
  const { t } = useContext(LocalizationContext);
  const { id } = useParams();
  const {
    state: {
      settings: { isBonusSystemEnabled, currency },
    },
  } = useContext(SettingsContext);
  const typePresentOptions: Array<ISelectOption> = [
    { title: t('discount'), value: EPromoValueType.DISCOUNT },
    { title: t('promo.present.type'), value: EPromoValueType.DEPOSIT },
    {
      title: t('promo.type.present.bonus'),
      value: EPromoValueType.BONUS,
      disabled: !isBonusSystemEnabled,
    },
  ];

  const rewardType = watch('rewardType');

  return (
    <div className={s.frame}>
      <div className={s.header}>
        <div className={s.left}>
          <H3>{t('promo.main.info')}</H3>
        </div>
        {id && (
          <div className={s.right}>
            {t('promo.main.info.use', String(usedCodes), String(totalCodes))}
          </div>
        )}
      </div>

      <Controller
        render={({ field: { name, ...field }, fieldState: { error } }) => (
          <Input
            {...field}
            title={t('title')}
            name="name"
            error={error?.message}
            bordered
            className={s.promo_input}
            maxLength={24}
          />
        )}
        name="title"
        control={control}
        rules={{
          required: t('errors.required'),
          minLength: {
            value: 5,
            message: t('errors.minLength', 5),
          },
          maxLength: {
            value: 24,
            message: t('errors.maxLength', 24),
          },
        }}
      />

      <div className={s.flex}>
        <Controller
          render={({ field: { name, ...field }, fieldState: { error } }) => (
            <Select
              name={'type'}
              options={typePresentOptions}
              {...field}
              placeholder={t('promo.type.present')}
              error={error?.message}
              bordered
              disableClear
              disabled={promoOrPromoCampaign === 'campaign' && Boolean(id)}
            />
          )}
          name="rewardType"
          control={control}
          rules={{
            required: t('errors.required'),
          }}
        />
        <Controller
          render={({ field: { name, ...field }, fieldState: { error } }) => (
            <NumberInput
              {...field}
              title={getValuePresentTitle(t, rewardType)}
              error={error?.message}
              bordered
              disabled={
                !rewardType ||
                (promoOrPromoCampaign === 'campaign' && Boolean(id))
              }
              rightContent={getValuePresentIcon(rewardType, currency)}
            />
          )}
          name="rewardValue"
          control={control}
          rules={{
            required: t('errors.required'),
            max:
              rewardType === EPromoValueType.DISCOUNT
                ? {
                    value: 100,
                    message: t('errors.max', 100, '%'),
                  }
                : undefined,
          }}
        />
      </div>
    </div>
  );
};
